import { render, staticRenderFns } from "./scholarcyDes.vue?vue&type=template&id=643cc85b&scoped=true"
import script from "./scholarcyDes.vue?vue&type=script&lang=js"
export * from "./scholarcyDes.vue?vue&type=script&lang=js"
import style0 from "./scholarcyDes.vue?vue&type=style&index=0&id=643cc85b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643cc85b",
  null
  
)

export default component.exports